import RecommendedJobCard from './RecommendedJobCard'
export default RecommendedJobCard
